// Generated by Melange

import * as Buhta_cabinet__DummyTable from "../../components/molecules/Table/DummyTable.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__Kassa from "../../grpc/Kassa.js";
import * as Buhta_cabinet__PageNav from "../../components/molecules/PageNav.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__Search from "../../components/molecules/Search/Search.js";
import * as Buhta_cabinet__Shift from "../../components/organisms/Kassa/KKM/Shift.js";
import * as Buhta_cabinet__Shifts from "../../components/organisms/Kassa/KKM/Shifts.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ShiftsTab(Props) {
  let id = Props.id;
  let orgId = Props.orgId;
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const match = React.useState(function () {
    return false;
  });
  const setMaximizeShift = match[1];
  const maximizeShift = match[0];
  const match$1 = React.useState(function () {
    return 1;
  });
  const setPage = match$1[1];
  const page = match$1[0];
  const func = Buhta_cabinet__Kassa.ZxReportService.grid;
  const match$2 = Buhta_core__GrpcState.useGrid((function (param) {
    return Curry._2(func, param, id);
  }), undefined);
  const grid = match$2[0];
  const startCount = Math.imul(25, page - 1 | 0) + (
    typeof grid === "string" || grid.NAME !== "Data" ? 0 : 1
  ) | 0;
  const currentRecords = typeof grid === "string" || grid.NAME !== "Data" ? 0 : Stdlib__List.length(grid.VAL);
  let tmp;
  let exit = 0;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
    tmp = null;
  } else {
    switch (currentRoute.TAG) {
      case /* Org */ 6 :
        const match$3 = currentRoute._1;
        if (/* tag */ typeof match$3 === "number" || typeof match$3 === "string" || match$3.TAG !== /* Kassa */ 2) {
          tmp = null;
        } else {
          const match$4 = match$3._0._0;
          if (/* tag */ typeof match$4 === "number" || typeof match$4 === "string") {
            tmp = null;
          } else {
            const match$5 = match$4._1;
            if (/* tag */ typeof match$5 === "number" || typeof match$5 === "string" || match$5.TAG !== /* Journal */ 2) {
              tmp = null;
            } else {
              const match$6 = match$5._0;
              if (/* tag */ typeof match$6 === "number" || typeof match$6 === "string") {
                tmp = null;
              } else {
                let tmp$1 = match$6._0;
                if (/* tag */ typeof tmp$1 === "number" || typeof tmp$1 === "string" || tmp$1.TAG !== /* View */ 0) {
                  tmp = null;
                } else {
                  exit = 1;
                }
              }
            }
          }
        }
        break;
      case /* Admin */ 7 :
        const match$7 = currentRoute._0;
        if (/* tag */ typeof match$7 === "number" || typeof match$7 === "string" || match$7.TAG !== /* Orgs */ 1) {
          tmp = null;
        } else {
          const match$8 = match$7._0;
          if (/* tag */ typeof match$8 === "number" || typeof match$8 === "string") {
            tmp = null;
          } else {
            const match$9 = match$8._1;
            if (/* tag */ typeof match$9 === "number" || typeof match$9 === "string" || match$9.TAG !== /* Kassa */ 2) {
              tmp = null;
            } else {
              const match$10 = match$9._0._0;
              if (/* tag */ typeof match$10 === "number" || typeof match$10 === "string") {
                tmp = null;
              } else {
                const match$11 = match$10._1;
                if (/* tag */ typeof match$11 === "number" || typeof match$11 === "string" || match$11.TAG !== /* Journal */ 2) {
                  tmp = null;
                } else {
                  const match$12 = match$11._0;
                  if (/* tag */ typeof match$12 === "number" || typeof match$12 === "string") {
                    tmp = null;
                  } else {
                    let tmp$2 = match$12._0;
                    if (/* tag */ typeof tmp$2 === "number" || typeof tmp$2 === "string" || tmp$2.TAG !== /* View */ 0) {
                      tmp = null;
                    } else {
                      exit = 1;
                    }
                  }
                }
              }
            }
          }
        }
        break;
      default:
        tmp = null;
    }
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_cabinet__Shift.make, {
      kkm: id,
      maximizeShift: maximizeShift,
      onMaximize: (function (param) {
        Curry._1(setMaximizeShift, (function (param) {
          return !maximizeShift;
        }));
      }),
      orgId: orgId
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__Search.make, {
            dispatch: match$2[1],
            page: page,
            setPage: setPage,
            searchLength: 1
          }),
          typeof grid === "string" ? JsxRuntime.jsx(Buhta_cabinet__DummyTable.make, {}) : (
              grid.NAME === "Data" ? JsxRuntime.jsxs(React.Fragment, {
                  children: [
                    JsxRuntime.jsx(Buhta_cabinet__Shifts.make, {
                      id: id,
                      shifts: grid.VAL,
                      maximizeShift: maximizeShift,
                      orgId: orgId,
                      startCount: startCount,
                      page: page,
                      setPage: setPage,
                      currentRecords: currentRecords
                    }),
                    JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
                      page: page,
                      setPage: setPage,
                      currentRecords: currentRecords
                    })
                  ]
                }) : (console.log(grid.VAL), JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {}))
            )
        ],
        className: "flex flex-col w-full flex-auto overflow-y-auto"
      }),
      tmp
    ],
    className: "w-full flex flex-auto overflow-y-auto h-full"
  });
}

const make = ShiftsTab;

export {
  make,
}
/* Buhta_cabinet__DummyTable Not a pure module */
